import { CustomElement } from 'custom-elements-ts';
declare var Prism;

@CustomElement({
  tag: 'cts-code-example',
  template:'<div id="code"></div>',
  style: ':host{font-size:15px;padding:24px;display:block;overflow-x:auto;color:#bbb;max-height:500px}@media screen and (min-width:1000px){:host{font-size:17px;padding:32px}}code[class*="language-"]{color:#c5c8c6;text-shadow:0 1px rgba(0,0,0,0.3);font-family:Inconsolata,Monaco,Consolas,"Courier New",Courier,monospace;direction:ltr;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;line-height:1.5;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none}pre{margin:0}pre[class*="language-"]{color:#c5c8c6;text-shadow:0 1px rgba(0,0,0,0.3);font-family:Inconsolata,Monaco,Consolas,"Courier New",Courier,monospace;direction:ltr;text-align:left;white-space:pre;word-spacing:normal;word-break:normal;line-height:1.5;-moz-tab-size:4;-o-tab-size:4;tab-size:4;-webkit-hyphens:none;-moz-hyphens:none;-ms-hyphens:none;hyphens:none;padding:1em;overflow:auto;border-radius:.3em}:not(pre)>code[class*="language-"],pre[class*="language-"]{background:#1d1f21}:not(pre)>code[class*="language-"]{padding:.1em;border-radius:.3em}.token.comment,.token.prolog,.token.doctype,.token.cdata{color:#7c7c7c}.token.punctuation{color:#c5c8c6}.namespace{opacity:.7}.token.property,.token.keyword,.token.tag{color:#e06c75}.token.class-name{color:#ffffb6;text-decoration:underline}.token.boolean,.token.constant{color:#9c9}.token.symbol,.token.deleted{color:#f92672}.token.number{color:#ff73fd}.token.selector,.token.attr-name,.token.string,.token.char,.token.builtin,.token.inserted{color:#a8ff60}.token.variable{color:#c6c5fe}.token.operator{color:#ededed}.token.entity{color:#ffffb6}.token.url{color:#96cbfe}.language-css .token.string,.style .token.string{color:#87c38a}.token.atrule,.token.attr-value{color:#f9ee98}.token.function{color:#dad085}.token.regex{color:#e9c062}.token.important{color:#fd971f;font-weight:bold}.token.bold{font-weight:bold}.token.italic{font-style:italic}.token.entity{cursor:help}'
})
export class CodeExampleElement extends HTMLElement {
  public code;
  constructor() {
    super();
    const code = `
// Typescript
import { CustomElement, Prop, Listen } from 'custom-elements-ts';

@CustomElement({
  tag: 'cts-message',
  template: '<h1></h1>'
  style: '' // css styles here or can use styleUrl
})
export class MessageElement extends HTMLElement {

  @Listen('click')
  handleClick() {
    alert('what are you waiting for?');
  }

  @Prop() message: string;

  connectedCallback(){
    this.shadowRoot.querySelector('h1').innerHTML = this.message;
  }
}

// HTML
<cts-message message="npm install custom-elements-ts"></cts-message>
        `;
      this.code = Prism.highlight(code, Prism.languages.javascript);
  }

  connectedCallback() {
      this.shadowRoot.querySelector('#code').innerHTML = `<pre><code>${this.code}</code></pre>`;
  }
}